import ListaFacturacion from '../componentes/ListaFacturacion.vue'
// import FormFichajes from '../componentes/FormFichajes.vue'

const routes = [
   ...route(`/lista-facturacion`, ListaFacturacion, {
     Auth: true,    
  }),
//   ...route(`/guardar-fichaje`, FormFichajes, {
// 	Auth: true,    
//  }),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes